export default "__VITE_ASSET__CqoqJwpS__"